import { format, isBefore, isSameDay, parseISO } from 'date-fns';
import { Dateish } from '../enums/utilities';

export const DATE_FORMAT = 'yyyy-MM-dd';
export const MONTH_FORMAT = 'yyyy-MM';
export const DATETIME_FORMAT = 'yyyy-MM-dd @ h:mm a';
export const LOCAL_TIMEZONE = Intl.DateTimeFormat().resolvedOptions().timeZone;
export const LOCAL_TIMEZONE_OFFSET_H = new Date().getTimezoneOffset() / 60;

export class DateUtil {
  static castDate(value: Dateish): Date | undefined {
    if (!value) {
      return undefined;
    }

    if (typeof value === 'string') {
      return parseISO(value);
    }

    if (typeof value === 'object') {
      // it's a date
      return value;
    }

    return undefined;
  }

  static printDate(
    value: Dateish,
    formatString = DATE_FORMAT
  ): string | undefined {
    const dateValue = DateUtil.castDate(value);

    if (!dateValue) {
      return undefined;
    }

    return format(dateValue, formatString);
  }

  static printDateTime(
    value: Dateish,
    formatString = DATETIME_FORMAT
  ): string | undefined {
    const dateValue = DateUtil.castDate(value);

    if (!dateValue) {
      return undefined;
    }

    return format(dateValue, formatString);
  }

  static isSameDay(a: Dateish, b: Dateish): boolean {
    const safeA = DateUtil.castDate(a);
    const safeB = DateUtil.castDate(b);
    return safeA && safeB ? isSameDay(safeA, safeB) : false;
  }

  static isBefore(a: Dateish, b: Dateish): boolean {
    const safeA = DateUtil.castDate(a);
    const safeB = DateUtil.castDate(b);
    return safeA && safeB ? isBefore(safeA, safeB) : false;
  }
}
